export const PASSWORD_MIN_CHARACTER = 8;
export const PASSWORD_MAX_CHARACTER = 32;
export const ADMIN_DETAILS_KEY = 'silencio-user';
export const ADMIN_DETAILS_REMEMBER_KEY = 'silencio-user-remember';
export const DUO_EMAIL = 'duo-email';
export const IDLE_TIMEOUT_TIME = 1000 * 60 * 60 * 2; // 2 hours in milliseconds.
export const ALLOWED_REGISTRATION_TYPES_FOR_EMAIL_CHANGE = ['email', 'phone'];
export const PEAQ_SUBSCAN_BASE_URL = 'https://peaq.subscan.io/tx/';
export const PEAQ_WALLET_BASE_URL = 'https://peaq.subscan.io/account/';
export const OPEN_ZEPPELIN_TRANSACTION_PROPOSAL_BASE_URL =
  'https://defender.openzeppelin.com/#/transaction-proposals/';
export const WALLET_TRANSACTION_STATUS = {
  Pending: 'pending',
  Processing: 'processing',
  Done: 'done',
  Errored: 'errored',
  InReview: 'in-review',
  Approved: 'approved',
  Rejected: 'rejected',
  Refunded: 'refunded',
};
